export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/pattern_design.5bccf87.svg";